import { Card, Grid } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { DateRangeSelect } from "../../DateSelect/range"
import Autocomplete from "@mui/material/Autocomplete"
import FormField from "layouts/pages/account/components/FormField"
import typography from "assets/theme/base/typography"
import pxToRem from "assets/theme/functions/pxToRem"
import ChevronDownIcon from "assets/images/apollo-english/chevron-down.svg"
import moment from "moment"
import DataTable from "./table"
import { useState, useEffect, useMemo } from "react"
import { titleTypography, noteTypography } from "shared/styles/style"
import { useLazyGetDashboardClassQuery } from "shared/redux/endpoints/sso"
import { useSearchParams } from "react-router-dom"
import { useLazyGetClassQuery } from "shared/redux/endpoints/assistant"
import { useLazyGetClassByCodeQuery } from "shared/redux/endpoints/assistant"
import { useLazyGetSuggestionsQuery } from "shared/redux/endpoints/assistant"
import { useLazyGetClassSuggessionQuery } from "shared/redux/endpoints/assistant"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import makeStyles from "pages/style"
import MDSelect from "components/MDSelect"
import axios from "axios"
import { globalConfigs } from "configs"
import { ToastUtil } from "utilities/toastUtil"
import { useSelector } from "react-redux"

const customStyle = (disable) => ({
  minWidth: "150px",
  ...(disable && { backgroundColor: "#FAFAFA!important" }),
  borderRadius: "0.375rem",
  "& *": {
    fontFamily: "'Lexend', san-serif !important",
  },
  "& .MuiOutlinedInput-root": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "& input, & input::placeholder": {
    fontSize: "12px !important",
    lineHeight: "1.5!important",
    fontWeight: 400,
    fontFamily: typography.lexendFont,
  },

  "& input": {
    paddingLeft: `${pxToRem(14)} !important`,
  },
})

function Classes() {
  const classes = makeStyles()
  const [trigger] = useLazyGetDashboardClassQuery()
  const [searchParams, setSearchParams] = useSearchParams()
  const user = useSelector((state) => state.auth.user)
  const { userId } = user

  const groupKOC = searchParams.get("group-koc")
  const koc = searchParams.get("koc")
  const centre = searchParams.get("center")
  const levelName = searchParams.get("level-name") || ""
  const className = searchParams.get("class")
  const valueClassName = (className && className?.split(",")) || []
  const page = searchParams.get("page") || 0
  const size = searchParams.get("size") || 10
  const startDate =
    searchParams.get("start-date") ||
    moment(new Date()).startOf("isoweek").format("MM-DD-YYYY")
  const endDate =
    searchParams.get("end-date") ||
    moment(new Date()).endOf("isoweek").format("MM-DD-YYYY")

  const [totalPage, setTotalPage] = useState(1)

  const handlePrev = () => {
    searchParams.set("page", (page ?? 0) - 1)
    setSearchParams(searchParams)
  }

  const handleNext = () => {
    searchParams.set("page", (page ?? 0) + 1)
    setSearchParams(searchParams)
  }

  const setCurrentPage = (page) => {
    searchParams.set("page", page)
    setSearchParams(searchParams)
  }

  const setSize = (size) => {
    searchParams.set("size", size)
    setSearchParams(searchParams)
  }

  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "Center", accessor: "center", width: "10%" },
      { Header: "Class", accessor: "class", width: "20%" },
      { Header: "Group KOC", accessor: "groupKOC", width: "10%" },
      { Header: "KOC", accessor: "KOC", width: "10%" },
      { Header: "Level", accessor: "level", width: "10%" },
      { Header: "No. of student", accessor: "noOfStudents", width: "12.5%" },
      { Header: "No. of ontrack", accessor: "noOfOntrack", width: "12.5%" },
      {
        Header: "No. of outstanding",
        accessor: "noOfOutstanding",
        width: "12.5%",
      },
      { Header: "No. of offtrack", accessor: "noOfOfftrack", width: "12.5%" },
      {
        Header: "Offtrack percentage",
        accessor: "offtrackPercentage",
        width: "15%",
      },
    ],

    rows: [],
  })

  const [classTable, setClassTable] = useState([])
  const [centerNameOptions, setCenterNameOptions] = useState([])
  const [suggestions, setSuggestions] = useState({
    centerName: [],
    groupKOC: [],
    koc: [],
    levelName: [],
  })
  const [classSuggestions, setClassSuggestions] = useState([])

  const [step, setStep] = useState(
    className ? 5 : levelName ? 4 : koc ? 3 : groupKOC ? 2 : centre ? 1 : 0
  )

  const queryParams = useMemo(
    () => ({
      page: page ?? 0,
      size: size ?? 0,
      sort: "",
      startDate: startDate ? moment(startDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
      endDate: endDate ? moment(endDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
      groupKOC: groupKOC ?? "",
      centerName: centre ?? "",
      KOC: koc ?? "",
      levelName: levelName ?? "",
      classCode: className,
    }),
    [page, size, startDate, endDate, groupKOC, centre, koc, levelName, className]
  )

  const [triggerGetClass, { isFetching: isFetchingClass }] =
    useLazyGetClassQuery()
  const [triggerSuggestions, { isFetching: isFetchingSuggestions }] =
    useLazyGetSuggestionsQuery()
  const [
    triggerGetClassSuggession,
    { isFetching: isFetchingClassSuggestions },
  ] = useLazyGetClassSuggessionQuery()
  const [triggerGetClassByCode, { isFetching: isFetchingClassByCode }] =
    useLazyGetClassByCodeQuery()

  const handleFetchSuggestions = async (data) => {
    const response = await triggerSuggestions(data)
    if (response?.data?.status) {
      setSuggestions({
        centerName:
          response?.data?.data?.centerName?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        groupKOC:
          response?.data?.data?.groupKOC?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        koc:
          response?.data?.data?.koc?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
        levelName:
          response?.data?.data?.levelName?.map((item) => ({
            label: item,
            value: item,
          })) ?? [],
      })
    }
    return response
  }

  const handleFetchClassSuggestions = async (data) => {
    const response = await triggerGetClassSuggession(data)
    if (response?.data?.status) {
      setClassSuggestions(response?.data?.data)
    }
  }

  useEffect(() => {
    const fetchClasses = async () => {
      if (queryParams.classCode) {
        const response = await triggerGetClassByCode({
          code: queryParams.classCode,
          page: queryParams.page,
          size: queryParams.size,
          sort: queryParams.sort,
          startDate: queryParams.startDate,
          endDate: queryParams.endDate,
        })
        if (response?.data?.status) {
          setClassTable(response?.data?.data?.data ?? [])
          setTotalPage(response?.data?.data?.totalPage ?? 1)
        }
      } else {
        const response = await triggerGetClass({
          ...queryParams,
        })

        if (response?.data?.status) {
          setClassTable(response?.data?.data?.data ?? [])
          setTotalPage(response?.data?.data?.totalPage ?? 1)
        }
      }
    }
    void fetchClasses()
  }, [queryParams])

  useEffect(() => {
    handleFetchSuggestions({
      centerName: centre || "",
      groupKOC: groupKOC || "",
    }).then((result) => {
      if (result?.data?.status) {
        setCenterNameOptions(
          result?.data?.data?.centerName?.map((item) => ({
            label: item,
            value: item,
          })) ?? []
        )
      }
    })
  }, [])

  useEffect(() => {
    if (centre && groupKOC && koc && levelName && startDate && endDate) {
      handleFetchClassSuggestions({
        startDate: startDate ? moment(startDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
        endDate: endDate ? moment(endDate, "MM-DD-YYYY").format("DD-MM-YYYY") : "",
        groupKOC: groupKOC || "",
        KOC: koc || "",
        centerName: centre,
        levelName: levelName || "",
      })
    }
  }, [centre, groupKOC, koc, levelName, startDate, endDate])

  // useEffect(() => {
  //   if (!date) {
  //     searchParams.set("date", moment(new Date()).startOf("isoweek").format("MM-DD-YYYY"));
  //     setSearchParams(searchParams);
  //   }
  //   if (!size) {
  //     searchParams.set("size", 10);
  //     setSearchParams(searchParams);
  //   }
  //   if (!page) {
  //     searchParams.set("page", 0);
  //     setSearchParams(searchParams);
  //   }
  // }, [date, size, page]);

  const isFetching = useMemo(
    () =>
      isFetchingClass ||
      isFetchingSuggestions ||
      isFetchingClassSuggestions ||
      isFetchingClassByCode,
    [
      isFetchingClass,
      isFetchingSuggestions,
      isFetchingClassSuggestions,
      isFetchingClassByCode,
    ]
  )

  useEffect(() => {
    if (classTable) {
      const customDataRow = classTable.map((item, index) => {
        const ontrack = Number(item?.ontrack ?? 0)
        const outstanding = Number(item?.outstanding ?? 0)
        const offtrack = Number(item?.offtrack ?? 0)

        const denom = ontrack + outstanding + offtrack
        const offtrackPercentage = denom > 0 ? (offtrack / denom) * 100 : 0

        return {
          // ===== IDs / Keys =====
          id: item?.id,
          classId: item?.classId,
          classCode: item?.classCode,

          // ===== Center / Class / Course =====
          centerId: item?.centerId,
          center: item?.centerName,
          class: item?.className,
          groupKOC: item?.courseGroupName,
          KOC: item?.courseName,

          levelId: item?.levelId,
          level: item?.levelName,

          // ===== Date range / week info =====
          startDate: moment(item?.startDate).format("DD-MM-YYYY"), // item?.startDate,
          endDate: moment(item?.endDate).format("DD-MM-YYYY"), // item?.endDate,
          weekStart: moment(item?.weekStart).format("DD-MM-YYYY"), // item?.weekStart,
          weekEnd: moment(item?.weekEnd).format("DD-MM-YYYY"), // item?.weekEnd,

          // ===== Teacher / sessions =====
          teacherId: item?.teacherId,
          totalSessionInWeek: item?.totalSessionInWeek,

          // ===== Student stats =====
          noOfStudents: item?.totalStudent,
          noOfOntrack: item?.ontrack,
          noOfOutstanding: item?.outstanding, // nếu API có trả
          noOfOfftrack: item?.offtrack,

          atRisk: item?.atRisk,
          excelling: item?.excelling,

          // ===== Percentages =====
          offtrackPct: item?.offtrackPct, // nếu API có sẵn
          offtrackPercentage: `${offtrackPercentage.toFixed(2)}%`,

          // ===== LMS =====
          apolloLmsClassUrl: item?.apolloLmsClassUrl,

          LMS: (
            <MDBox
              sx={{
                backgroundColor: "#2576B9",
                color: "#FFFFFF !important",
                padding: "5px 10px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation()
                axios
                  .post(
                    globalConfigs.urlSSOLms +
                      "/auth/redirect-my-apollo/generate",
                    {
                      hubUserId: userId,
                      type: "CLASS_DETAIL",
                      hubClassId: item?.classId,
                    },
                    {
                      headers: { "x-api-key": globalConfigs.apiKeySSO },
                    }
                  )
                  .then((res) => {
                    const link =
                      res?.data?.redirectLink || item?.apolloLmsClassUrl
                    if (link) window.open(link, "_blank")
                  })
                  .catch(() => {
                    ToastUtil.showToastError("Can't open LMS. Please try again")
                  })
              }}
            >
              Go to LMS
            </MDBox>
          ),
        }
      })
      setDataTable({
        columns: [
          { Header: "Center", accessor: "center", width: "10%" },
          { Header: "Class", accessor: "class", width: "15%" },
          { Header: "Group KOC", accessor: "groupKOC", width: "10%" },
          { Header: "KOC", accessor: "KOC", width: "10%" },
          { Header: "Level", accessor: "level", width: "10%" },

          // ===== Date range / week info =====
          { Header: "Start date", accessor: "startDate", width: "10%" },
          { Header: "End date", accessor: "endDate", width: "10%" },
          { Header: "Week start", accessor: "weekStart", width: "10%" },
          { Header: "Week end", accessor: "weekEnd", width: "10%" },

          // ===== Teacher / sessions =====
          { Header: "Teacher", accessor: "teacherId", width: "10%" },
          {
            Header: "Sessions/week",
            accessor: "totalSessionInWeek",
            width: "10%",
          },

          // ===== Student stats =====
          { Header: "Total", accessor: "noOfStudents", width: "8%" },
          { Header: "Offtrack", accessor: "noOfOfftrack", width: "8%" },
          { Header: "Ontrack", accessor: "noOfOntrack", width: "8%" },
          // { Header: "Outstanding", accessor: "noOfOutstanding", width: "8%" },

          // ===== Extra stats =====
          { Header: "At risk", accessor: "atRisk", width: "8%" },
          { Header: "Excelling", accessor: "excelling", width: "8%" },

          // ===== Percentages =====
          // nếu API có sẵn offtrackPct thì bật cột này
          // { Header: "Offtrack pct (API)", accessor: "offtrackPct", width: "10%" },

          {
            Header: "Offtrack percentage",
            accessor: "offtrackPercentage",
            width: "10%",
          },

          // ===== LMS =====
          { Header: "LMS", accessor: "LMS", width: "10%" },
        ],
        rows: customDataRow || [],
      })
    }
  }, [classTable])

  return (
    <MDBox mb={3}>
      <Card>
        <MDBox p={3} lineHeight={1}>
          <InfoIcon
            type={TooltipType.TYPE_1}
            teacherInfoIconBlock={teacherInfoIconBlock.CLASS_LIST}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWithHeading}
          >
            <MDTypography
              sx={({ breakpoints }) => ({ ...titleTypography(breakpoints) })}
            >
              Class list
            </MDTypography>
          </InfoIcon>
        </MDBox>
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          px={3}
          pb={3}
          sx={({ breakpoints }) => ({
            [breakpoints.down("lg")]: {
              justifyContent: "flex-start",
            },
          })}
        >
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <DateRangeSelect
              onChangeStartDate={(e) => {
                searchParams.set("start-date", moment(e).format("MM-DD-YYYY"))
                setSearchParams(searchParams)
              }}
              onChangeEndDate={(e) => {
                searchParams.set("end-date", moment(e).format("MM-DD-YYYY"))
                setSearchParams(searchParams)
              }}
              defaultStartDate={startDate}
              defaultEndDate={endDate}
              disable={isFetching}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Centre
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={centerNameOptions || []}
              isDisabled={
                centerNameOptions?.length === 0 || isFetching
              }
              onChange={(e) => {
                searchParams.set("center", e.value ?? "")
                searchParams.delete("group-koc")
                searchParams.delete("koc")
                searchParams.delete("level-name")
                searchParams.delete("class")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: e.value || "",
                  groupKOC: "",
                  KOC: "",
                })
                if (e.value) {
                  setStep(1)
                } else {
                  setStep(0)
                }
              }}
              placeholder="Select Centre"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Group KOC
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.groupKOC || []}
              isDisabled={
                suggestions?.groupKOC?.length === 0 || isFetching || step < 1
              }
              onChange={(e) => {
                searchParams.set("group-koc", e.value ?? "")
                searchParams.delete("koc")
                searchParams.delete("level-name")
                searchParams.delete("class")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: centre || "",
                  groupKOC: e.value || "",
                  KOC: "",
                })
                if (e.value) {
                  setStep(2)
                } else {
                  setStep(1)
                }
              }}
              placeholder="Group KOC"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.5}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              KOC
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.koc || []}
              isDisabled={
                suggestions?.koc?.length === 0 || isFetching || step < 2
              }
              onChange={(e) => {
                searchParams.set("koc", e.value ?? "")
                searchParams.delete("level-name")
                searchParams.delete("class")
                setSearchParams(searchParams)
                handleFetchSuggestions({
                  centerName: centre || "",
                  groupKOC: groupKOC || "",
                  KOC: e.value || "",
                })
                if (e.value) {
                  setStep(3)
                } else {
                  setStep(2)
                }
              }}
              placeholder="KOC"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={1.5}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Level
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={suggestions?.levelName || []}
              isDisabled={
                suggestions?.levelName?.length === 0 || isFetching || step < 3
              }
              value={levelName ? { label: levelName, value: levelName } : null}
              onChange={(e) => {
                if (e?.value) {
                  searchParams.set("level-name", e.value)
                  setStep(4)
                } else {
                  searchParams.delete("level-name")
                  setStep(3)
                }
                searchParams.delete("class")
                setSearchParams(searchParams)
              }}
              placeholder="Level"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#344767",
              })}
            >
              Class
            </MDTypography>
            <MDSelect
              className="input input-search input-search-select"
              options={classSuggestions.map((item) => ({
                value: item.value,
                label: item.value,
              }))}
              isDisabled={
                classSuggestions?.length === 0 || isFetching || step < 4
              }
              onChange={(e) => {
                searchParams.set("class", e.value ?? "")
                setSearchParams(searchParams)
                if (e.value) {
                  setStep(5)
                } else {
                  setStep(4)
                }
              }}
              placeholder="Class"
            />
          </Grid>
        </Grid>

        <DataTable
          table={dataTable}
          isSorted={false}
          currentPage={parseInt(queryParams.page || 0)}
          handlePrev={handlePrev}
          handleNext={handleNext}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
          isLoading={isFetching}
          isEmpty={classTable.length === 0}
          classPageSize={parseInt(queryParams.size || 10)}
          setClassPageSize={setSize}
          startDateClass={
            queryParams.startDate ||
            moment(new Date()).startOf("isoweek").format("DD-MM-YYYY")
          }
          endDateClass={
            queryParams.endDate ||
            moment(new Date()).endOf("isoweek").format("DD-MM-YYYY")
          }
        />
      </Card>
    </MDBox>
  )
}

export { Classes }
